import { Navigate, useNavigate } from "react-router-dom";
import img from "../.././assets/login_logo.png";
import { FaLongArrowAltRight } from "react-icons/fa";
import { useEffect, useState } from "react";
import { usePostLoginMutation } from "../../store/api/adminapi";
import {
  storeAuthToken,
  storeUserName,
  getAuthToken,
  storeUseremail
} from "../../Localstorage/Localstorage";
import { Helmet } from "react-helmet";

const Login = () => {
  const [loginapi] = usePostLoginMutation();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [message, setMessage] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const nvg = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      nvg("/dashboard/");
    }
  }, [nvg]);

  const handleLogin = async (force = false) => {
    try {
      const jsondata = {
        usr: username,
        pwd: password,
        ...(force && { force: true })
      };
      

      const response = await loginapi(jsondata);
      console.log("API Response:", response);

      if (response.error) {
        setMessage(response.error.data?.message || "Login failed!");
        if(response.error.data?.message === "User already logged in from another device.") {
          setShowConfirmation(true);
        }
      } else {
        setMessage(response.data.message);
        if (response.data.message === "Logged In") {
          storeAuthToken(response.data.key_details);
          storeUserName(response.data.full_name);
          storeUseremail(response.data.user)
          nvg("/dashboard/");
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage("Something went wrong. Please try again.");
    }
  };




  const loginsubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setShowConfirmation(false);
    await handleLogin(false);
  };


  

  const handleForceLogin = async () => {
    setShowConfirmation(false);
    await handleLogin(true);
  };

  return (
    <>
    <Helmet>
				<title>Login</title>
			</Helmet>
    <div className="login-container">
      <div className="upper-section">
        <div className="login-box">
          <img src={img} alt="logo" style={{ maxWidth: "70px" }} />
          <div className="logo">Login to StackerBee WMS</div>
        </div>
      </div>
      <form onSubmit={loginsubmit}>
        <div className="lower-section">
          <div className="login-box" style={{ paddingBottom: "0px" }}>
            <div className="login-form">
              <div className="controlinput">
                <input
                  type="text"
                  name="username"
                  value={username}
                  className="px-1"
                  onChange={(e) => setusername(e.target.value)}
                  placeholder="Username"
                  required
                />
              </div>
              <div className="controlinput">
                <input
                  type="password"
                  name="password"
                  className="px-1"
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  placeholder="Password"
                  required
                />
              </div>
            </div>
          </div>
          <div className="login-box">
            <div className="login-form">
              <button type="submit" style={{ background: "#ec642a" }}>
                LOG IN &nbsp; <FaLongArrowAltRight size={16} />
              </button>
            </div>
          </div>

          {/* Display API response message */}
          {message && (
            <div
              style={{
                marginTop: "10px",
                color: message === "Logged In" ? "green" : "red",
                textAlign: "center",
              }}
            >
              {message}
            </div>
          )}
        </div>
      </form>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{color:"#2e0b79"}}>Session Conflict</h3>
            <p className="p-0 m-0">User already logged in from another device. Do you want to logout from the other device and continue here?</p>
            <div className="modal-actions">
              <button onClick={handleForceLogin} className="confirm-btn">
                Yes, log me in
              </button>
              <button onClick={() => setShowConfirmation(false)} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add some CSS for the modal */}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 8px;
          max-width: 400px;
          width: 90%;
          text-align: center;
        }
        .modal-actions {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-top: 20px;
        }
        .confirm-btn {
          background: #ec642a;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
        }
        .cancel-btn {
          background: #f0f0f0;
          color: #333;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
      </div>
    </>
  );
};

export default Login;